import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export default api;

export const endpoints = {
  settings: () => api.get("/settings").then((r) => r.data),
  services: () => api.get("/services").then((r) => r.data),
  service: (slug) => api.get(`/services/${slug}`).then((r) => r.data),
  projects: () => api.get("/projects").then((r) => r.data),
  testimonials: () => api.get("/testimonials").then((r) => r.data),
  categories: () => api.get("/categories").then((r) => r.data),
  products: (params = {}) =>
    api.get("/products", { params }).then((r) => r.data),
  product: (slug) => api.get(`/products/${slug}`).then((r) => r.data),
  createQuote: (payload) =>
    api.post("/quote-requests", payload).then((r) => r.data),
};

// Extract a human-readable Arabic error message from a FastAPI/pydantic error
export function extractErrorAr(err) {
  const fallback = "حدث خطأ غير متوقع، حاول مرة أخرى.";
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    const field = first?.loc?.slice(-1)?.[0];
    if (field === "phone") return "رقم الهاتف غير صحيح، يرجى إدخال رقم صالح.";
    if (field === "name") return "الاسم مطلوب.";
    return first?.msg || fallback;
  }
  return fallback;
}
